// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Reports.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import Header from './Izenda.Header';
import constants from 'logic/data/Izenda.PermissionConstants';

const Reports = connect()(props => {
  const { model, localization } = props;
  const header = {
    component: Header,
    headerName: localization.getText('COMMON_LABEL_REPORTS'),
    model
  };

  const className = 'grid-small-column u_borderRight u-bgWhite';
  const mediumClassName = 'grid-medium-column u_borderRight u-bgWhite';

  return (
    <Panel
      className='u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder'
      header={header}
      collapsible
      expanedOption={model.collapseAll}
    >
      <GridLayout>
        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_CAN_CREATE_NEW_REPORTS')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.canCreateNewReport.value' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_DATA_SOURCES')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_SIMPLE_DATA_SOURCE')}
              </span>
            </GridLayout.Col>
            <RightPanelContent
              model={model}
              keysPath='reports.dataSources.simpleDataSources'
              showRadioButton
              isParent
            />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_ADVANCED_DATA_SOURCE')}
              </span>
            </GridLayout.Col>
            <RightPanelContent
              model={model}
              keysPath='reports.dataSources.advancedDataSources'
              showRadioButton
              isParent
            />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_REPORT_PART_TYPES')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CHART')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.reportPartTypes.chart' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FORM')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.reportPartTypes.form' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_GAUGE')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.reportPartTypes.gauge' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_MAP')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.reportPartTypes.map' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_REPORT_CATEGORIES_SUBCATEGORIES')}
                </span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_CAN_CREATE_NEW_REPORTS')}
              </span>
            </GridLayout.Col>
            <RightPanelContent
              model={model}
              keysPath='reports.reportCategoriesSubcategories.canCreateNewCategory.value'
            />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CATEGORIES_ACCESSIBILITY')}
              </span>
            </GridLayout.Col>
            <RightPanelContent isParent model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue izenda-Permission-LargeRow'>
            <GridLayout.Col cols='3' className={mediumClassName}>
              <span className='izenda-Permission-SecondChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_VISIBLE_CATEGORIES')}
              </span>
            </GridLayout.Col>
            <RightPanelContent
              isParent
              notShowBlankCharacter
              model={model}
              showRole
              popupTitle={localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_VISIBLE_REPORT_CATEGORIES')}
              popupMessage={localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_REPORT_VIEW')}
              treeType={constants.TREE_TYPE.CATEGORY}
              visibleCategories
              keysPath='reports.reportCategoriesSubcategories.categoryAccessibility.categories'
            />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue izenda-Permission-LargeRow'>
            <GridLayout.Col cols='3' className={mediumClassName}>
              <span className='izenda-Permission-SecondChild'>
                {localization.getText(
                  'ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CATEGORIES_ALLOWED_FOR_SAVING_REPORTS'
                )}
              </span>
            </GridLayout.Col>
            <RightPanelContent
              isParent
              notShowBlankCharacter
              model={model}
              showRole
              popupTitle={localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SAVING_REPORT_CATEGORIES')}
              popupMessage={localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_ROLE_CATEGORY_SUBCATEGORY_REPORT_SAVE')}
              treeType={constants.TREE_TYPE.CATEGORY}
              savableCategories
              keysPath='reports.reportCategoriesSubcategories.categoryAccessibility.categories'
            />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FILTERS_PROPERTIES')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FILTERS_LOGIC')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.filterProperties.filterLogic' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CROSS_FILTERING')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.filterProperties.crossFiltering' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_FIELD_PROPERTIES')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_CUSTOM_URL')}</span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.fieldProperties.customURL' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('COMMON_LABEL_EMBEDDED_JAVASCRIPT')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.fieldProperties.embeddedJavaScript' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_SUBREPORT')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.fieldProperties.subreport' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('COMMON_LABEL_ACTIONS')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_SCHEDULE')}</span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.schedule' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_REGISTER_FOR_ALERTS')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.registerForAlerts' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_SUBSCRIBE')}</span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.subscribe' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_CONFIGURE_ACCESS_RIGHT')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.configureAccessRights' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_EMAIL')}</span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.email' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_PRINT')}</span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.print' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_EXPORT')}</span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.exporting' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_VIEW_REPORT_HISTORY')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.viewReportHistory' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_UNARCHIVE_REPORT_VERSIONS')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.unarchiveReportVersions' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_DELETE')}</span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.del' />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_REPORTS_LABEL_OVERWRITE_EXISTING_REPORT')}
              </span>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='reports.actions.overwriteExistingReport' />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    </Panel>
  );
});

export default Reports;



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.Reports.js